import { createContext, useContext, type ReactNode } from 'react'

type MobileMenuContextValue = {
  openMenu: () => void
}

const MobileMenuContext = createContext<MobileMenuContextValue | null>(null)

export function MobileMenuProvider({ children, openMenu }: { children: ReactNode; openMenu: () => void }) {
  return <MobileMenuContext.Provider value={{ openMenu }}>{children}</MobileMenuContext.Provider>
}

export function useMobileMenu() {
  return useContext(MobileMenuContext)
}
